import * as React from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { styles } from "../../views/OrderDetailsView.styles";
import { BlueButton } from "../../components/Buttons/BlueButton";

export interface IBaseCurrenciesComponentProps extends WithStyles<typeof styles> {
    currencies: any[],
    detailsDialogOpen: boolean,
    setDetailsDialogOpen: any,
    subscriptionRequestId?: string
}

const BaseCurrenciesComponentPure: React.FunctionComponent<IBaseCurrenciesComponentProps> = ({ classes, currencies, detailsDialogOpen, setDetailsDialogOpen, subscriptionRequestId }: IBaseCurrenciesComponentProps) => {

    return <>
        <Dialog open={detailsDialogOpen} fullWidth maxWidth={"sm"} scroll={"paper"}>
            <DialogTitle id="show-details-dialog">
                Selected assets
            </DialogTitle>
            <DialogContent dividers={true}>
                <DialogContentText>
                <Grid container spacing={2} direction="column">
                        {subscriptionRequestId
                        ? <Grid item xs={10}>
                            <Typography variant="h5">Subscription request id:</Typography>
                            <Typography variant="body2">{subscriptionRequestId}</Typography>
                        </Grid>
                        : null}
                        <Grid item xs={10}>
                            <Typography variant="h5">Assets:</Typography>
                            <Typography variant="body2">{currencies}</Typography>
                        </Grid>
                    </Grid>
                    
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <BlueButton onClick={() => setDetailsDialogOpen(false)}>Close</BlueButton>
            </DialogActions>
        </Dialog>
    </>;
};

export const BaseCurrenciesComponent = withStyles(styles)(BaseCurrenciesComponentPure);
